import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import styles from "./Pages.module.css";

function ComputerRepairShreveport() {
  return (
    <div className={styles.pageWrapper}>
      <Helmet>
        <title>Computer Repair in Shreveport-Bossier City | Tharpe Industries</title>
        <meta name="description" content="Local computer repair in Shreveport and Bossier City. Slow computers, virus removal, hard drive failures, and data recovery. Same-area service. No shipping required." />
        <meta name="keywords" content="computer repair Shreveport, laptop repair Bossier City, virus removal Shreveport, hard drive repair Louisiana, local computer help Shreveport" />
        <link rel="canonical" href="https://tharpeindustries.com/computer-repair-shreveport" />
      </Helmet>

      <div className={styles.pageHero}>
        <div className={styles.contentContainer}>
          <p className={styles.sectionEyebrow}>Shreveport & Bossier City</p>
          <h1>Local Computer Repair, Shreveport-Bossier</h1>
          <p className={styles.heroSubtext}>Something wrong with your computer? Austin Tharpe is a local technician serving small businesses and professionals in the Shreveport-Bossier City area. No shipping, no call centers, local help.</p>
          <div className={styles.heroCtas}>
            <Link to="/contact-us" className="btn btn-primary">Describe the Problem →</Link>
            <Link to="/computer-repair" className={styles.heroSecondaryLink}>See what I fix</Link>
          </div>
        </div>
      </div>

      <div className={styles.pageSection}>
        <div className={styles.contentContainer}>
          <div className={styles.textContent}>
            <h2>Common computer problems I fix in Shreveport-Bossier</h2>
            <ul className={styles.benefitList}>
              <li><strong>Slow or freezing computers</strong>, Running too slow? Taking forever to start up? Usually fixable without replacing the whole machine.</li>
              <li><strong>Virus and malware removal</strong>, Strange pop-ups, browser redirects, or a computer that's suddenly acting weird. I clean it up and secure it so it doesn't happen again.</li>
              <li><strong>Hard drive failures</strong>, Clicking sounds, "disk not found" errors, or files that suddenly disappeared. I diagnose whether the drive is failing and what data can be recovered.</li>
              <li><strong>Data recovery</strong>, Accidentally deleted files, a crashed drive, or a computer that won't boot. I attempt recovery before replacing anything.</li>
              <li><strong>Laptop screen repairs</strong>, Cracked or broken screens on business laptops. We assess whether repair or replacement is the better value for your situation.</li>
              <li><strong>Software installation and setup</strong>, New computer, fresh install, software won't open, printer won't connect. I handle the setup so you don't have to.</li>
              <li><strong>Network and Wi-Fi issues</strong>, Can't connect, slow speeds, dropping constantly. I diagnose whether it's your device, your router, or your ISP.</li>
            </ul>

            <h2>Why use a local technician instead of shipping it off?</h2>
            <p>When you ship a computer to a big repair chain, you lose it for days or weeks and pay for shipping on top of the repair. With a local technician, you get a real person who comes to you (or you drop off locally), explains what's wrong in plain English, and fixes it without the runaround.</p>
            <p>Austin serves small businesses and professionals in Shreveport, Bossier City, and the surrounding area. If you're not sure whether your problem is worth fixing or if it makes more sense to replace the machine, he'll tell you honestly, not just take your money.</p>

            <h2>Pricing</h2>
            <p>Most repairs start with a diagnostic. Once I know what's wrong, I'll give you a clear price before doing any work.</p>
            <ul className={styles.benefitList}>
              <li><strong>Remote diagnostics and fixes:</strong> Many software problems, virus removals, and setup issues can be handled remotely, faster and lower cost.</li>
              <li><strong>On-site or drop-off repairs:</strong> Hardware issues (screens, drives, ports) require hands-on work. We serve the Shreveport-Bossier area.</li>
              <li><strong>No surprise charges:</strong> You get a price before work starts. No hidden fees.</li>
            </ul>

            <p>For businesses needing ongoing support (not just one-time repairs), see the <Link to="/managed-it-services">monthly IT support plans</Link>, often more cost-effective than paying per incident.</p>

            <div className={styles.relatedPages}>
              <p className={styles.relatedPagesHeading}>Related services:</p>
              <div className={styles.relatedPageLinks}>
                <Link to="/computer-repair">Computer Repair Services</Link>
                <Link to="/managed-it-services-shreveport">Managed IT, Shreveport</Link>
                <Link to="/managed-it-services">Managed IT Plans</Link>
                <Link to="/it-health-check">IT Health Check, $149</Link>
                <Link to="/cybersecurity">Cybersecurity</Link>
              </div>
            </div>

            <div style={{ marginTop: '2rem' }}>
              <p><strong>Ready to get it fixed?</strong> <Link to="/contact-us">Send a message</Link> describing what's happening and I'll let you know if it can be fixed remotely or needs hands-on attention.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ComputerRepairShreveport;
